import { defineRouting } from 'next-intl/routing';
import { BASE_PATH, LOCALE_COOKIE } from '@/_constants';
import { MESSAGES_MAP } from './constants';

export const routing = defineRouting({
  locales: Object.keys(MESSAGES_MAP),
  defaultLocale: MESSAGES_MAP.ru,
  localePrefix: 'always',
  localeCookie: {
    name: LOCALE_COOKIE,
    sameSite: 'lax' as const,
    path: BASE_PATH || '/',
  },
});
